import { runtimeConfig } from '../config/runtime-config';

export function resolveApiBaseUrl(apiBaseUrl?: string | (() => string)): string {
  if (typeof apiBaseUrl === 'function') {
    return apiBaseUrl();
  }

  return apiBaseUrl ?? runtimeConfig.apiBaseUrl;
}
